import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#deposit-accounts-table-app', App);
